import { render, staticRenderFns } from "./NavJwtvItem.vue?vue&type=template&id=0fec8c88&scoped=true"
import script from "./NavJwtvItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavJwtvItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavJwtvItem.vue?vue&type=style&index=0&id=0fec8c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec8c88",
  null
  
)

export default component.exports